import { render, staticRenderFns } from "./fillDetail.vue?vue&type=template&id=172bf25d&scoped=true"
import script from "./fillDetail.vue?vue&type=script&lang=js"
export * from "./fillDetail.vue?vue&type=script&lang=js"
import style0 from "./fillDetail.vue?vue&type=style&index=0&id=172bf25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172bf25d",
  null
  
)

export default component.exports